import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconButton, TextField, Tooltip } from '@emburse/embark-core';
import { CopyIcon } from '@emburse/embark-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
function CopyableTextField({ id, value, type, helperText, readOnly }) {
    const { t } = useTranslation();
    const defaultTooltipText = t('Copy to clipboard');
    const [tooltipText, setTooltipText] = useState(defaultTooltipText);
    const resetTooltipText = () => {
        setTooltipText(defaultTooltipText);
    };
    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText('');
        window.navigator.clipboard.writeText(value);
        setTooltipText(t('Copied!'));
    };
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { id: id, value: value, type: type, readOnly: readOnly, helperText: helperText }), _jsx(Tooltip, { title: tooltipText, placement: "top", onOpen: resetTooltipText, children: _jsx(IconButton, { onClick: handleCopyToClipboard, children: _jsx(Icon, { iconUrl: CopyIcon }) }) })] }));
}
export default CopyableTextField;
